import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
// import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
// import { ActivatedRoute } from '@angular/router';

import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { AuthService } from '../../../providers/auth/auth.service';
import { CustomerProvider } from '../../../providers/customer/customer';
import { UserProvider } from '../../../providers/user/user';
import { I18nProvider } from '../../../providers/i18n/i18n';


@Component({
  selector: 'component-customer-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss']
})
export class CustomerNotesComponent implements OnChanges {
  protected headers: any;
  @Input() studentData: any = null;

  @Output() closeNotes = new EventEmitter<void>();
  search = '';
  confirming: number | 'all' | null = null;
  deleting = false;
  loadError = false;
  private loadVersion = 0;

  get filteredNotes(): any[] {
    const term = this.helpers.removeDiacritics(this.search.trim().toLowerCase());
    return (this.notes || []).filter(note => {
      const text = [note.note || '', this.noteName(note.workout), this.noteName(note.program),
        this.noteName(note.training), this.noteName(note.training, 'subtitle')].join(' ');
      return !term || this.helpers.removeDiacritics(text.toLowerCase()).includes(term);
    });
  }

  noteName(value: any, field = 'name'): string {
    return value ? this.helpers.returnTranslation(value, field) || '' : '';
  }

  noteDay(note: any): string {
    const date = String(note.updated_at || note.created_at || '').slice(0, 10);
    return /^\d{4}-\d{2}-\d{2}$/.test(date) && !isNaN(Date.parse(date)) ? date : '';
  }

  searchChanged() {
    this.confirming = null;
  }

  requestDelete(target: number | 'all') {
    if (this.loading || this.deleting || this.loadError) return;
    this.confirming = this.confirming === target ? null : target;
  }

  async confirmDelete() {
    if (this.confirming === null || this.loading || this.deleting || this.loadError) return;
    const version = this.loadVersion;
    const pending = this.confirming === 'all' ? this.notes.slice() : this.notes.filter(note => note.id === this.confirming);
    this.deleting = true;
    try {
      for (const note of pending) {
        await this.userProv.deleteWorkoustNotes(note.id);
        if (version === this.loadVersion) this.notes = this.notes.filter(item => item.id !== note.id);
      }
      if (version === this.loadVersion) this.confirming = null;
    } catch (error) {
      this.toastr.error('Não foi possível concluir a exclusão. As anotações restantes foram mantidas. Tente novamente.', '', this.helpers.toastrCfgs);
    } finally {
      this.deleting = false;
    }
  }

  loading: boolean = false;
  notes = [];

  PAGE: any;
  STRINGS: any;


  constructor(
    public toastr: ToastrService,
    public auth: AuthService,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    // private route: ActivatedRoute,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('CustomerNotesComponent');

    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentData) {
      this.search = '';
      this.confirming = null;
      this.getNotes(this.studentData && this.studentData.id);
    }
  }

  async getNotes(id: number = 0) {
    const version = ++this.loadVersion;
    this.confirming = null;
    this.notes = [];
    this.loadError = false;
    if (!id) { this.loading = false; return; }
    this.loading = true;
    try {
      const res: any = await this.userProv.getWorkoustNotes(id);
      if (version !== this.loadVersion) return;
      this.notes = (res.notes || []).slice().sort((a, b) =>
        String(b.updated_at || b.created_at || '').localeCompare(String(a.updated_at || a.created_at || '')));
    } catch (error) {
      if (version !== this.loadVersion) return;
      this.loadError = true;
      this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
    } finally {
      if (version === this.loadVersion) this.loading = false;
    }
  }

  select(workout: any) {
    console.log(workout);
  }

  delete(note: any) {
    // console.log(note);
    this.loading = true;
    this.userProv.deleteWorkoustNotes(note.id).then(
      (res: any) => {
        this.loading = false;
        this.notes = res.notes;
      },
      (err: any) => {
        console.log(err);
        this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        this.notes = null;
        this.loading = false;
      }
    );
  }

  deleteAll() {
    // console.log(this.studentData);
    this.loading = true;
    this.userProv.deleteAllWorkoustNotes().then(
      (res: any) => {
        this.loading = false;
        this.notes = res.notes;
      },
      (err: any) => {
        console.log(err);
        this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
        this.notes = null;
        this.loading = false;
      }
    );
  }
}
